import { useEffect, useState } from "react";
import { tss } from "tss-react";
import { Menu, Input, InputAdornment } from "@mui/material";
import EventsEmitter from "events/EventsEmitter";
import { Scrollbars } from "react-custom-scrollbars";
import { ArrowDropDown } from "@mui/icons-material";

const useStyles = tss.create({
    root: {
        width: "100%",
    },
    content: {
        marginLeft: -15,
    },
    input: {
        textAlign: "left",
        " & input": {
            cursor: "pointer",
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
        },
    },
    menu: {
        "& div": {
            overflow: "hidden",
        },
    },
});

type IProps = {
    content: any;
    children: any;
    className?: any;
    style?: any;
    menuListProps?: any;
    menuMaxHeight?: number;
    maxWidth?: number;
    disableUnderline?: boolean;
};

export default function CustomRichSelect(props: IProps) {
    var { classes, cx } = useStyles();
    var { content, className, style, children, menuListProps, menuMaxHeight, maxWidth, disableUnderline } = props;
    var [anchorEl, setAnchorEl] = useState(null);

    useEffect(() => {
        const closeMenu = () => {
            setAnchorEl(null);
        };
        EventsEmitter.on("closeMenu", closeMenu);
        return () => {
            EventsEmitter.removeEventListener("closeMenu", closeMenu);
        };
    }, []);

    const handleMenu = (evt: any) => {
        setAnchorEl(evt.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div className={classes.root}>
            {content === null ? (
                <Input
                    value={""}
                    onClick={handleMenu}
                    className={cx(className, classes.input)}
                    style={style}
                    disableUnderline={disableUnderline}
                    endAdornment={
                        <InputAdornment position="end">
                            <ArrowDropDown fontSize="small" />
                        </InputAdornment>
                    }
                    spellCheck={false}
                />
            ) : (
                <div
                    className={classes.content}
                    onClick={handleMenu}
                    style={{
                        maxWidth: maxWidth ? maxWidth : 250,
                        borderBottom: !disableUnderline ? "1px solid rgba(0, 0, 0, 0.42)" : "",
                    }}
                >
                    {content}
                </div>
            )}
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                }}
                MenuListProps={menuListProps}
                className={classes.menu}
            >
                <Scrollbars
                    autoHeight
                    autoHeightMax={menuMaxHeight ? menuMaxHeight : 180}
                    style={{ overflowX: "hidden", width: "100%," }}
                >
                    {children}
                </Scrollbars>
            </Menu>
        </div>
    );
}
